<template>
  <div class="manage-page">
    <iframe
      :src="iframeSrc"
      frameborder="0"
      allow="clipboard-read; clipboard-write"
    />
  </div>
</template>

<script>

import {useRoute} from 'vue-router/dist/vue-router'
import {computed} from 'vue'

export default {
  name: 'OrderManage',
  setup() {
    const route = useRoute()

    const iframeSrc = computed(() => {
      const url = new URL('https://calc.apex-tech.ru/iframe/manage/?color=%23e42c31&')
      Object.entries(route.query || {}).forEach(([key, value]) => {
        url.searchParams.set(key, value.toString())
      })
      return url.href
    })

    return {
      iframeSrc
    }
  }
}
</script>

<style scoped>
.manage-page {
  padding-top: 50px;
  background-color: #f9f9f9;
}
iframe {
  height: calc(100vh - 197px);
  max-width: 100%;
  width: 100%;
}
@media screen and (max-width: 768px) {

}
</style>
